import { assertNever } from 'utils/type-guard/assertNever'
import { SupplierPageTab } from './supplierPageTab'

export const generateSupplierRoute = ({ supplierId, tab }: { supplierId: string; tab?: SupplierPageTab }): string => {
  const prefix = `/suppliers/detail/${supplierId}`

  if (!tab) {
    return prefix
  }

  switch (tab) {
    case 'overview':
      return `${prefix}/overview`
    case 'activity':
      return `${prefix}/activity`
    case 'documents':
      return `${prefix}/documents`
    case 'risk-management':
      return `${prefix}/risk-management`
    case 'contacts':
      return `${prefix}/contacts`
    default:
      assertNever(tab)
      return prefix
  }
}
